import React, { useState, useEffect } from "react";
import InputField from "../../../component/input-field";
import "../../../css/theme.css";
import SwitchInputField from "../../../component/switch-input-field";
import { useSelector, useDispatch } from "react-redux";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import {
  addNewComponent,
  updateComponent,
  deleteComponentById,
} from "../../../redux/actions/manageComponent";
import Tippy from "@tippyjs/react";
import { sanitizeInput } from "../../../utils";
import UploadExcelFile from "./UploadExcelFile";
import Select from "react-select";
import * as XLSX from "xlsx";

const defaultStateVal = {
  componentName: "",
  componentPlaceholder: "",
  componentTooltip: "",
  isCheckedByDefault: false,
  validation: [],
  minimumValue: "",
  maximumValue: "",
  link_url: "",
  priorDate: true,
  futureDate: true,
};

function ComponentSetting({
  update,
  setUpdate,
  showWatermark,
  setShowWatermark,
  dropdownOptions,
  setDropdownOptions,
  componentParameter,
  setComponentParameter,
}) {
  const dispatch = useDispatch();

  // Default Configs for date/time picker
  const defaultConfigs = [
    {
      title: "Allow Prior Date",
      checked: true,
    },
    {
      title: "Allow Future Date",
      checked: true,
    },
  ];

  // Default error state
  const defaultError = {
    componentName: false,
    componentPlaceholder: false,
    // minimumValue: false,
    // maximumValue: false,
    link_url: false,
    dropdownErrorIndex: "",
  };

  // Validation Options
  const validationOptions = [
    {
      label: "Check Container Number",
      value: "Check Container Number",
    },
    {
      label: "Check Vehicle Number",
      value: "Check Vehicle Number",
    },
  ];

  const [configs, setConfigs] = useState(defaultConfigs); // State to store prior and future date

  const [error, setError] = useState(defaultError); //Error state to show error mesaage

  const [openUploadExcelModal, setOpenUploadExcelModal] = useState(false); //State to open upload modal pop-up

  // Reset Error state when component get changed.
  useEffect(() => {
    setError(defaultError);
    setConfigs([
      {
        title: "Allow Prior Date",
        checked: componentParameter.priorDate,
      },
      {
        title: "Allow Future Date",
        checked: componentParameter.futureDate,
      },
    ]);
  }, [componentParameter]);

  // Function to get different icon
  const getIcon = (type) => {
    const iconMap = {
      text: "fas fa-text",
      dropdown: "fas fa-caret-square-down",
      toggle: "fas fa-toggle-on",
      "date/time": "far fa-calendar",
      "check box": "fas fa-check-square",
      link: "fas fa-link",
      "radio group": "fa-solid fa-circle-dot",
      paragraph: "fa-solid fa-p",
      number: "fa-solid fa-n",
    };

    const iconClass = iconMap[type];

    if (iconClass) {
      return <span className={`${iconClass} text-[--bg-color-500]`}></span>;
    } else {
      return null; // Return null or a default icon if needed for the default case
    }
  };

  // Remove dropdown item
  const removeDropdownItem = (elementToRemove) => {
    setDropdownOptions(
      dropdownOptions.filter((element, index) => index !== elementToRemove)
    );
    const findValue = dropdownOptions.find((ele, index) => index === elementToRemove);
    if(findValue && findValue?.value === componentParameter?.listSelectedValue?.value){
      setComponentParameter({
        ...componentParameter,
        listSelectedValue: null
      });
    }
  };

  // Add dropdown value
  const addDropdownValue = (option, indexVal) => {
    setDropdownOptions((prev) => {
      return prev.map((item, index) => {
        if (index === indexVal) {
          item.label = option;
          item.value = option;
        }
        return item;
      });
    });
  };

  // Function which store boolean value for prior and future date
  const handleCheck = (index) => {
    const newConfigs = [...configs];
    newConfigs[index].checked = !newConfigs[index].checked;
    setConfigs(newConfigs);

    setComponentParameter({
      ...componentParameter,
      priorDate: newConfigs[0].checked,
      futureDate: newConfigs[1].checked,
    });
  };

  // Function to check Link URL is valid or not
  const validate_Link_URL = (value) => {
    if (value.includes("https://") || value.includes("http://")) {
      const urlPattern =
        /(https+:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https+:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

      return urlPattern.test(value);
    }

    return false;
  };

  // Function to check Validation
  const isEmpty = (value) => !value?.trim();

  const hasNoErrors = (newErrors) =>
    Object.values(newErrors).every((error) => !error);

  const checkValidation = () => {
    const newErrors = { ...error };
    newErrors.componentName = isEmpty(componentParameter.componentName);

    const componentPayload = {
      label: componentParameter.componentName,
      type: componentParameter.componentType.toLowerCase(),
      placeholder: componentParameter.componentPlaceholder,
      min: componentParameter.minimumValue
        ? componentParameter.minimumValue
        : null,
      max: componentParameter.maximumValue
        ? componentParameter.maximumValue
        : null,
      tooltip: componentParameter.componentTooltip
        ? componentParameter.componentTooltip
        : null,
      prior_date: configs[0].checked,
      future_date: configs[1].checked,
      list_values:
        dropdownOptions &&
        dropdownOptions.filter((item) => item.value).length > 0
          ? JSON.stringify(
              dropdownOptions
                .filter((item) => item.value)
                .map((obj) => obj.value)
            )
          : null,
      is_check_by_default: componentParameter.isCheckedByDefault
        ? componentParameter.isCheckedByDefault
        : false,
      url: componentParameter.link_url ? componentParameter.link_url : null,
      list_selected_value: componentParameter?.listSelectedValue ? componentParameter?.listSelectedValue.value : null
    };

    if (componentParameter.component_special_id) {
      componentPayload.component_name = componentParameter.component_special_id;
    }

    switch (componentParameter.componentType) {
      case "text":
      case "number": {
        newErrors.componentPlaceholder = isEmpty(
          componentParameter.componentPlaceholder
        );

        setError(newErrors);

        if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      }
      case "paragraph": {
        newErrors.componentPlaceholder = isEmpty(
          componentParameter.componentPlaceholder
        );

        setError(newErrors);

        if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      }
      case "date/time": {
        newErrors.componentPlaceholder = isEmpty(
          componentParameter.componentPlaceholder
        );

        setError(newErrors);
        if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      }
      case "dropdown": {
        newErrors.componentPlaceholder = isEmpty(
          componentParameter.componentPlaceholder
        );

        setError(newErrors);
        if (
          dropdownOptions.some((obj) => {
            const trimmedValue = obj?.value?.trim();
            return !trimmedValue;
          })
        ) {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Dropdown item cannot be empty."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else if (
          dropdownOptions.some((obj, index, array) => {
            return array.some((otherObj, otherIndex) => {
              return (
                index !== otherIndex &&
                obj.value.trim() === otherObj.value.trim()
              );
            });
          })
        ) {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Dublicate entry in dropdown items."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      }

      case "link": {
        const trimmedLinkUrl = componentParameter.link_url.trim();

        if (!trimmedLinkUrl) {
          newErrors.link_url = "This field is required";
        } else if (!validate_Link_URL(componentParameter.link_url)) {
          newErrors.link_url = "Invalid URL";
        } else {
          newErrors.link_url = false;
        }

        setError(newErrors);
        if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      }
      case "radio group":
        setError(newErrors);
        if (
          dropdownOptions.some((obj) => {
            const trimmedValue = obj?.value?.trim();
            return !trimmedValue;
          })
        ) {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Radio item cannot be empty."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else if (
          dropdownOptions.some((obj, index, array) => {
            return array.some((otherObj, otherIndex) => {
              return (
                index !== otherIndex &&
                obj.value.trim() === otherObj.value.trim()
              );
            });
          })
        ) {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Dublicate entry in radio items."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;
      case "check box":
      case "toggle":
        setError(newErrors);
        if (hasNoErrors(newErrors)) {
          handleComplete(componentPayload);
        }
        break;

      default:
        break;
    }
  };

  const handleComplete = (componentPayload) => {
    const request = {
      body: componentPayload,
      onSuccess: () => {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={
                componentParameter.componentId
                  ? "Component has been updated successfully."
                  : "Component has been created successfully."
              }
              onClick={() => {
                setShowWatermark(!showWatermark);
                setUpdate(update + 1);
                setComponentParameter(defaultStateVal);
                setDropdownOptions([]);
              }}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    if (componentParameter.componentId) {
      request.componentId = componentParameter.componentId;
      dispatch(updateComponent(request));
    } else {
      dispatch(addNewComponent(request));
    }
  };

  const handleSave = () => {
    const newErrors = { ...error };
    newErrors.componentName = isEmpty(componentParameter.componentName);

    if (!hasNoErrors(newErrors)) {
      return swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content="Component Name field is mandatory to save the component."
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }

    const savedData = {
      label: componentParameter.componentName,
      type: componentParameter.componentType.toLowerCase(),
      placeholder: componentParameter.componentPlaceholder,
      tooltip: componentParameter.componentTooltip,
    };
    switch (componentParameter.componentType) {
      case "text":
      case "number":
        // savedData.min = componentParameter.minimumValue;
        // savedData.max = componentParameter.maximumValue;
        break;

      case "date/time":
        savedData.prior_date = configs[0].checked;
        savedData.future_date = configs[1].checked;
        break;

      case "dropdown":
        savedData.list_values = JSON.stringify(
          dropdownOptions.map((item) => item.value)
        );
        break;

      case "check box":
      case "radio group":
      case "toggle":
        savedData.is_check_by_default = componentParameter.isCheckedByDefault;
        break;
      default:
        break;
    }

    const request = {
      body: savedData,
      onSuccess: () => {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Component has been saved successfully."
              onClick={() => {
                setShowWatermark(!showWatermark);
                setUpdate(update + 1);
                setComponentParameter(defaultStateVal);
                setDropdownOptions([]);
              }}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    if (componentParameter.componentId) {
      request.componentId = componentParameter.componentId;
      dispatch(updateComponent(request));
    } else {
      dispatch(addNewComponent(request));
    }
  };

  const handleDelete = () => {
    const request = {
      componentId: componentParameter.componentId,
      onSuccess: () => {
        setUpdate(update + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Component has been deleted successfully."
              onClick={() => {
                setShowWatermark(!showWatermark);
                setComponentParameter(defaultStateVal);
                setDropdownOptions([]);
              }}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(deleteComponentById(request));
  };

  // Function to check unique dropdown value
  const checkUniqueDropdownValue = (value, index) => {
    const isDuplicate =
      dropdownOptions.length > 1 &&
      dropdownOptions.some(
        (element) => element?.value?.trim() === value?.trim()
      );
    setError({ ...error, dropdownErrorIndex: isDuplicate ? index : "" });
    addDropdownValue(value, index);
  };

  // Funtion to handle excel file upload
  const handleExcelFileUpload = (e) => {
    const file = e;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming you're reading the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      const dropDownOptionsInExcel = jsonData.map((ele) => {
        const obj = {
          label: ele.Items,
          value: ele.Items,
        };
        return obj;
      });
      if (dropdownOptions.length > 0 && dropdownOptions[0].value) {
        setDropdownOptions([...dropdownOptions, ...dropDownOptionsInExcel]);
      } else {
        setDropdownOptions([...dropDownOptionsInExcel]);
      }
      setOpenUploadExcelModal(false);
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div
      className="relative h-screen py-3 space-y-4"
      style={{ maxHeight: "calc(100vh - 135px)" }}
    >
      {/* ---------------- Body ---------------- */}
      <div className="bg-[--bg-color-50] rounded p-3 space-y-3 overflow-y-auto 2xl:h-[180px]">
        <h4 className="text-sm font-bold leading-3 tracking-tight text-[#535860]">
          Component Details
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-1 sm:gap-2 md:gap-4 overflow-y-auto">
          <div className="flex-1 space-y-1">
            <label className={`block text-sm font-medium text-[#535860]`}>
              Component Type
            </label>
            <div className="bg-white h-[38px] rounded flex items-center px-2 py-2 space-x-2 border">
              {getIcon(componentParameter.componentType)}
              <h6 className="text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500] capitalize">
                {componentParameter.componentType}
              </h6>
            </div>
          </div>
          <div>
            <InputField
              type="text"
              label="Component ID"
              labelClass="leading-3 tracking-tight"
              disabled
              value={componentParameter.component_special_id}
            />
          </div>
        </div>
      </div>

      <div
        className={`bg-[--bg-color-50] rounded p-3 space-y-3 overflow-y-auto h-full component_specific_configuration`}
      >
        <div className="space-y-3">
          <h4 className="text-sm font-bold leading-3 tracking-tight text-[#535860]">
            Component Configurations
          </h4>
          <div>
            {componentParameter.componentType !== "toggle" &&
            componentParameter.componentType !== "radio group" &&
            componentParameter.componentType !== "check box" ? (
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-1 sm:gap-2 md:gap-4 overflow-y-auto">
                <div>
                  <InputField
                    type="text"
                    label="Component Name"
                    placeholder="Enter Component Name"
                    labelClass="leading-3 tracking-tight"
                    required
                    onChange={(event) => {
                      const value = sanitizeInput(event.target.value);
                      setComponentParameter({
                        ...componentParameter,
                        componentName: value,
                      });
                      setError({ ...error, componentName: false });
                    }}
                    value={componentParameter.componentName}
                    error={
                      error.componentName ? "This field is required" : null
                    }
                    disabled={componentParameter.is_immutable}
                  />
                </div>
                {componentParameter.componentType === "link" ? (
                  <div>
                    <InputField
                      type="url"
                      label="Link URL"
                      placeholder="Enter Link URL"
                      labelClass="leading-3 tracking-tight"
                      required
                      onChange={(event) => {
                        const value = sanitizeInput(event.target.value);
                        setComponentParameter({
                          ...componentParameter,
                          link_url: value,
                        });

                        setError({ ...error, link_url: false });
                      }}
                      value={componentParameter.link_url}
                      error={error.link_url ? error.link_url : null}
                      disabled={componentParameter.is_immutable}
                    />
                  </div>
                ) : (
                  <div>
                    <InputField
                      type="text"
                      label="Component Placeholder"
                      placeholder="Enter Component Placeholder"
                      labelClass="leading-3 tracking-tight"
                      required
                      onChange={(event) => {
                        const value = sanitizeInput(event.target.value);
                        setComponentParameter({
                          ...componentParameter,
                          componentPlaceholder: value,
                        });
                        setError({ ...error, componentPlaceholder: false });
                      }}
                      value={
                        componentParameter.componentPlaceholder
                          ? componentParameter.componentPlaceholder
                          : ""
                      }
                      error={
                        error.componentPlaceholder
                          ? "This field is required"
                          : null
                      }
                      disabled={componentParameter.is_immutable}
                    />
                  </div>
                )}
                <div>
                  <div className="flex items-center justify-between">
                    <label className={`block text-sm font-medium mb-1`}>
                      Help Text
                    </label>

                    <Tippy content="I am a help text">
                      <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
                    </Tippy>
                  </div>

                  <div className="relative">
                    <textarea
                      rows="2"
                      className={`w-full form-textarea resize-none ${
                        componentParameter.is_immutable && "bg-slate-200"
                      }`}
                      placeholder="Enter Help Text"
                      onChange={(event) => {
                        const value = sanitizeInput(event.target.value);
                        setComponentParameter({
                          ...componentParameter,
                          componentTooltip: value,
                        });
                      }}
                      value={
                        componentParameter.componentTooltip
                          ? componentParameter.componentTooltip
                          : ""
                      }
                      disabled={componentParameter.is_immutable}
                    ></textarea>
                  </div>
                </div>

                {componentParameter.componentType === "dropdown" && (
                  <div className="w-full">
                    <div className="flex items-center justify-between">
                      <label
                        className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate`}
                        title={"Default Selected Value"}
                      >
                        Default Selected Value
                      </label>
                      {/* <Tippy
                        content={componentParameter.componentTooltip}
                        className="break-words"
                      > */}
                        {/* <span
                          className={`fas fa-info-circle fill-current ${
                            isSelected ? "text-white" : "text-[--bg-color-500]"
                          }  cursor-pointer text-sm`}
                        ></span> */}
                      {/* </Tippy> */}
                    </div>
            
                  <div className="relative">
                    <Select
                      options={
                        dropdownOptions.filter((element, index) => element?.label).length >
                        0
                          ? dropdownOptions.filter((element, index) => element?.label)
                          : []
                      }
                      isClearable={true}
                      value={
                        componentParameter?.listSelectedValue
                          ? componentParameter.listSelectedValue
                          : ""
                      }
                      onChange={(e) => {
                        if (setComponentParameter) {
                          setComponentParameter({
                            ...componentParameter,
                            listSelectedValue: e,
                          });
                        }
                      }}
                      menuPortalTarget={document.body}
                      className="unresetText"
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        placeholder: (provided, state) => ({
                          ...provided,
                          color: "#9B9B9B", // Set your desired color here
                          fontSize: "14px",
                        }),
                      }}
                      placeholder={"Select default value"}
                      menuPlacement="auto"
                    />
                  </div>
                </div>
                )}

              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-1 sm:gap-2 md:gap-4 overflow-y-auto">
                <div>
                  <InputField
                    type="text"
                    label={
                      componentParameter.componentType !== "radio group"
                        ? "Label"
                        : "Component Name"
                    }
                    placeholder={
                      componentParameter.componentType !== "radio group"
                        ? "Enter Label Name"
                        : "Enter Component Name"
                    }
                    labelClass="leading-3 tracking-tight"
                    required
                    onChange={(event) => {
                      const value = sanitizeInput(event.target.value);
                      setComponentParameter({
                        ...componentParameter,
                        componentName: value,
                      });
                      setError({ ...error, componentName: false });
                    }}
                    value={componentParameter.componentName}
                    error={
                      error.componentName ? "This field is required" : null
                    }
                    disabled={componentParameter.is_immutable}
                  />
                </div>

                {componentParameter.componentType === "radio group" && (
                  <div className="w-full">
                    <div className="flex items-center justify-between">
                      <label
                        className={`block text-sm font-medium mb-1 w-full overflow-hidden truncate`}
                        title={"Default Selected Value"}
                      >
                        Default Selected Value
                      </label>
                      {/* <Tippy
                        content={componentParameter.componentTooltip}
                        className="break-words"
                      > */}
                        {/* <span
                          className={`fas fa-info-circle fill-current ${
                            isSelected ? "text-white" : "text-[--bg-color-500]"
                          }  cursor-pointer text-sm`}
                        ></span> */}
                      {/* </Tippy> */}
                    </div>
            
                  <div className="relative">
                    <Select
                      options={
                        dropdownOptions.filter((element, index) => element?.label).length >
                        0
                          ? dropdownOptions.filter((element, index) => element?.label)
                          : []
                      }
                      isClearable={true}
                      value={
                        componentParameter?.listSelectedValue
                          ? componentParameter.listSelectedValue
                          : ""
                      }
                      onChange={(e) => {
                        if (setComponentParameter) {
                          setComponentParameter({
                            ...componentParameter,
                            listSelectedValue: e,
                          });
                        }
                      }}
                      menuPortalTarget={document.body}
                      className="unresetText"
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        placeholder: (provided, state) => ({
                          ...provided,
                          color: "#9B9B9B", // Set your desired color here
                          fontSize: "14px",
                        }),
                      }}
                      placeholder={"Select default value"}
                      menuPlacement="auto"
                    />
                  </div>
                </div>
                )}

                {componentParameter.componentType !== "radio group" && (
                  <div className="flex justify-start items-center">
                    <div className="flex items-center space-x-3">
                      <input
                        id="controlSetting1"
                        type="checkbox"
                        name="Advance Control Setting"
                        className="form-checkbox"
                        checked={componentParameter.isCheckedByDefault}
                        onChange={() =>
                          setComponentParameter({
                            ...componentParameter,
                            isCheckedByDefault:
                              !componentParameter.isCheckedByDefault,
                          })
                        }
                        disabled={componentParameter.is_immutable}
                      />
                      <label
                        htmlFor="controlSetting1"
                        className="text-sm font-medium cursor-pointer"
                      >
                        is checked by default
                      </label>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {componentParameter.componentType !== "toggle" &&
          componentParameter.componentType !== "check box" &&
          componentParameter.componentType !== "paragraph" &&
          componentParameter.componentType !== "link" && (
            <div className="space-y-3">
              <h4 className="text-sm font-bold leading-3 tracking-tight text-[#535860]">
                Component Specific Configuration
              </h4>
              {componentParameter.componentType === "dropdown" && (
                <>
                  <div className="space-y-2">
                    <h6 className="text-[13px] font-medium leading-3 tracking-tight text-[#535860]">
                      Dropbox Items
                    </h6>

                    <button
                      className="btn bg-[--bg-color-500] text-white w-full space-x-2"
                      onClick={() => setOpenUploadExcelModal(true)}
                    >
                      <span className="fa-solid fa-upload"></span>
                      <span>Upload Excel</span>
                    </button>

                    <div className="flex items-center space-x-2">
                      <div className="border-t border-slate-300 grow"></div>
                      <div className="">or</div>
                      <div className="border-t border-slate-300 grow"></div>
                    </div>

                    <div className="space-y-2">
                      {dropdownOptions.map((item, index) => (
                        <InputField
                          key={index}
                          type="text"
                          onChange={(event) => {
                            const value = sanitizeInput(event.target.value);
                            checkUniqueDropdownValue(value, index);
                          }}
                          value={item.value ? item.value : ""}
                          suffix={
                            dropdownOptions.length > 1 ? (
                              <span
                                className="text-sm font-semibold leading-3 tracking-tight text-[#EB5757] cursor-pointer"
                                onClick={() => removeDropdownItem(index)}
                              >
                                Remove
                              </span>
                            ) : null
                          }
                          labelClass="hidden"
                          disabled={componentParameter.is_immutable}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-start items-center">
                    <h6
                      className={`text-xs font-semibold leading-3 tracking-tight ${
                        error.dropdownErrorIndex === 0 ||
                        error.dropdownErrorIndex
                          ? "text-slate-500 cursor-not-allowed pointer-events-none"
                          : "text-[--bg-color-500] cursor-pointer"
                      } `}
                      onClick={() =>
                        setDropdownOptions([
                          ...dropdownOptions,
                          { label: null, value: null },
                        ])
                      }
                    >
                      + Add Item
                    </h6>
                  </div>
                </>
              )}
              {componentParameter.componentType === "radio group" && (
                <>
                  <div className="space-y-2">
                    <h6 className="text-[13px] font-medium leading-3 tracking-tight text-[#535860]">
                      Radio Items
                    </h6>
                    <button
                      className="btn bg-[--bg-color-500] text-white w-full space-x-2"
                      onClick={() => setOpenUploadExcelModal(true)}
                    >
                      <span className="fa-solid fa-upload"></span>
                      <span>Upload Excel</span>
                    </button>

                    <div className="flex items-center space-x-2">
                      <div className="border-t border-slate-300 grow"></div>
                      <div className="">or</div>
                      <div className="border-t border-slate-300 grow"></div>
                    </div>

                    <div className="space-y-2">
                      {dropdownOptions.map((item, index) => (
                        <InputField
                          key={index}
                          type="text"
                          onChange={(event) => {
                            const value = sanitizeInput(event.target.value);
                            checkUniqueDropdownValue(value, index);
                          }}
                          value={item.value ? item.value : ""}
                          suffix={
                            dropdownOptions.length >= 2 ? (
                              <span
                                className="text-sm font-semibold leading-3 tracking-tight text-[#EB5757] cursor-pointer"
                                onClick={() => removeDropdownItem(index)}
                              >
                                Remove
                              </span>
                            ) : null
                          }
                          labelClass="hidden"
                          disabled={componentParameter.is_immutable}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-start items-center">
                    <h6
                      className={`text-xs font-semibold leading-3 tracking-tight ${
                        error.dropdownErrorIndex === 0 ||
                        error.dropdownErrorIndex
                          ? "text-slate-500 cursor-not-allowed pointer-events-none"
                          : "text-[--bg-color-500] cursor-pointer"
                      } `}
                      onClick={() =>
                        setDropdownOptions([
                          ...dropdownOptions,
                          { label: null, value: null },
                        ])
                      }
                    >
                      + Add Item
                    </h6>
                  </div>
                </>
              )}
              {(componentParameter.componentType === "text" ||
                componentParameter.componentType === "number") && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {componentParameter.componentType !== "paragraph" &&
                    componentParameter.componentType !== "link" && (
                      <div>
                        <InputField
                          type="number"
                          label="Set minimum characters"
                          placeholder="Enter minimum value"
                          onChange={(event) => {
                            setComponentParameter({
                              ...componentParameter,
                              minimumValue: event.target.value,
                            });
                          }}
                          value={
                            componentParameter.minimumValue
                              ? componentParameter.minimumValue
                              : ""
                          }
                          disabled={componentParameter.is_immutable}
                        />
                      </div>
                    )}
                  {componentParameter.componentType !== "paragraph" &&
                    componentParameter.componentType !== "link" && (
                      <div>
                        <InputField
                          type="number"
                          label="Set maximum characters"
                          placeholder="Enter maximum value"
                          onChange={(event) => {
                            setComponentParameter({
                              ...componentParameter,
                              maximumValue: event.target.value,
                            });
                          }}
                          value={
                            componentParameter.maximumValue
                              ? componentParameter.maximumValue
                              : ""
                          }
                          disabled={componentParameter.is_immutable}
                        />
                      </div>
                    )}
                </div>
              )}
              {componentParameter.componentType === "date/time" && (
                <div className="space-y-3">
                  {configs.map((item, index) => (
                    <SwitchInputField
                      key={index}
                      tag="div"
                      tagClass="border-0"
                      index={index}
                      description={item.title}
                      checked={item.checked}
                      wrapperCSS="text-[#475569] font-medium leading-[22px]"
                      onCheck={() => handleCheck(index)}
                      disabled={componentParameter.is_immutable}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
      </div>
      {/* --------------- Footer ----------------*/}
      <div className="w-full py-2 flex justify-end items-center absolute bottom-0">
        <div className="space-x-4">
          {componentParameter.componentId && (
            <button
              className={`btn bg-white border-slate-200 hover:border-slate-300 ${
                componentParameter.is_immutable
                  ? "text-slate-400 pointer-events-none"
                  : "text-slate-600 cursor-pointer"
              } `}
              disabled={componentParameter.is_immutable}
              onClick={() =>
                swal({
                  content: (
                    <CustomeModal
                      type="delete"
                      title="Are you sure?"
                      content="This action cannot be undone."
                      onDelete={() => handleDelete()}
                    />
                  ),
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                })
              }
            >
              Delete
            </button>
          )}
          <button
            className={`btn ${
              componentParameter.is_immutable
                ? "bg-[--bg-color-300] pointer-events-none"
                : "bg-[--bg-color-500] hover:bg-[--bg-color-700] cursor-pointer"
            }  text-white `}
            onClick={() => checkValidation()}
            disabled={componentParameter.is_immutable}
          >
            {componentParameter.componentId ? "Update" : "Complete"}
          </button>
        </div>
      </div>

      {/* --------------- Modal Pop-up ---------- */}
      <UploadExcelFile
        openUploadExcelModal={openUploadExcelModal}
        setOpenUploadExcelModal={setOpenUploadExcelModal}
        handleExcelFileUpload={handleExcelFileUpload}
      />
    </div>
  );
}

export default ComponentSetting;
